<template>
  <div :class="['flip-pic', { 'flip-pic--flipped': flipped }]">
    <div :class="['flip-pic__recto', recto]" />

    <div :class="['flip-pic__verso', verso]" />
  </div>
</template>

<script>
export default {
  name: 'FlipPic',

  props: {
    recto: { type: String, default: '' },
    verso: { type: String, default: '' },
    flipped: { type: Boolean, default: false },
  },
};
</script>

<style lang="stylus" scoped>
  $fipTime = 0.25s;
  .flip-pic {
    position: relative;
    perspective: 500px;

    &__recto {
      transform: rotateX(360deg);
      transition: transform $fipTime ease-out $fipTime;

      .flip-pic--flipped & {
        transform: rotateX(270deg);
        transition: transform $fipTime ease-in;
      }
    }

    &__verso {
      position: absolute;
      top: 0;
      left: 0;

      transform: rotateX(450deg);
      transition: transform $fipTime ease-in;

      .flip-pic--flipped & {
        transform: rotateX(360deg);
        transition: transform $fipTime ease-out $fipTime;
      }
    }
  }
</style>
